import React, { FC } from 'react';
import { TSeriesListingProps } from '../@shared/seriesListing/types/seriesListing.types';
import { SeriesListingModel } from '../@shared/seriesListing/models/seriesListing.model';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import SeriesListing from '../@shared/seriesListing';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import { lineSeriesVisible } from '../../constants/analytics.constants';

const ProductSeriesListing: FC<TSeriesListingProps> = (props) => {
  const model = new SeriesListingModel(props);
  const apiResponse = isEmptyResponse(props) && props?.fields?.apiData?.items && props?.fields?.apiData?.items?.length > 0;
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  return (
    <AnalyticsVisibleEvent event={lineSeriesVisible}>
      <SeriesListing {...props}>{''}</SeriesListing>
    </AnalyticsVisibleEvent>
  );
};

export default ProductSeriesListing;
